import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import StockMutationCard from "../../../../../components/global/cards/stock/StockMutationCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShDoubleTextSkeleton from "../../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useGetStockMutationsQuery } from "../../../../../newapi/warehouse/stockSlice";
import { tokens } from "../../../../../theme";
import { getStockMutationMessage } from '../../../../../utils/logs';
import { STOCK_MUTATION_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';

const SpLocationDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpLocationDetails/SpLocationDetails"));

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [
        STOCK_MUTATION_FILTER_KEYS.RELATION,
        STOCK_MUTATION_FILTER_KEYS.PRODUCT,
        STOCK_MUTATION_FILTER_KEYS.TYPE,
        STOCK_MUTATION_FILTER_KEYS.WAREHOUSE,
        STOCK_MUTATION_FILTER_KEYS.USER,
        STOCK_MUTATION_FILTER_KEYS.DATERANGE
    ],
};

const Mutations = (props) => {
    const { t, i18n,ready } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [locationIsExtended, setLocationIsExtended] = useState(false);
    const [spLocationLoading, setSpLocationLoading] = useState();

  

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    const [productData, setProductData] = useState({});
    const getProductDetails = (params) => {
        // getProduct(params.id,(result, data) => {
        //     if (result) {
        //         console.log(data);
        //         setProductData(data);
        //         setIsExtended(true);
        //     }
        // });
    }

    const [locationId, setLocationId] = useState();
    const locationIdRef = useRef(locationId);
    
    const getLocationDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.stock?.warehouseLocation?.id);
        // Only update state if the productId has actually changed
        if (locationIdRef.current !== newProductId) {
            if(!spLocationLoading){
                setSpLocationLoading(true);
            }
            setLocationId(newProductId);
            locationIdRef.current = newProductId; // Update the ref to the new value
        }
        
            setLocationIsExtended(true);
    };

    const columns = [
        {
            field: "product",
            headerName: t('product'),
            flex:1,
            renderCell : (params) => {

                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }

                return(
                    <Box display={"flex"} flexDirection={"column"}>
                        <Text bold>
                        {params.row.stock.product?.sku}
                        </Text>
                        <Text light>
                        {params.row.stock.product?.description}
                        </Text>
                    </Box>
                )
            }
        },
        {
            field: "location",
            headerName: t('location'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton variant={"yellow"}/>
                }

                return (
                    <Box onClick={(event) => {
                        event.stopPropagation(); // Prevent click from propagating to the row
                        getLocationDetails(params);
                    }}
                        sx={{
                            cursor:"pointer"
                        }}
                    >
                        <ShLabel size={32} fitted variant={"yellow"}>
                            {params.row.stock.warehouseLocation?.location}
                        </ShLabel>
                    </Box>
                )
            },
        },
        {
            field: "created",
            headerName: t('created'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }

                return (
                    <Box display={"flex"} flexDirection={"column"}>
                        <Text fontWeight="500">
                            {typeof params.row.createdAt !== "undefined" ?
                                new Date(params.row.createdAt).toLocaleDateString(i18n.language)
                            : null}
                        </Text>
                        <Text light>
                            {typeof params.row.createdAt !== "undefined" ?
                                new Date(params.row.createdAt).toLocaleTimeString(i18n.language)
                            : null}
                        </Text>
                    </Box>
                )
            },
        },
        {
            field: "description", 
            headerName: t('description'),
            flex:3,
            renderCell : (cellValues) => {
                return getStockMutationMessage(cellValues.row, t);
            }
        },
        {
            field: "oldStock", 
            headerName: t('old_stock'),
            flex:1,
            renderCell : (cellValues) => {
                return cellValues.row.availableStock + (cellValues.row.mutation * -1);
            }
        },
        {
            field: "mutation", 
            headerName: t('mutation'),
            flex:1,
            renderCell : (cellValues) => {
                return cellValues.row.mutation;
            }
        },
        {
            field: "availableStock", 
            headerName: t('available_stock'),
            flex:1,
            renderCell : (cellValues) => {
                return cellValues.row.availableStock;
            }
        },
        ...isFulfilment ? [{
            field: "relation",
            headerName: t('relation'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.stock?.product?.relation?.name || ""
            },
        }] : [],
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            // hide: true,
            renderCell: (params) => {
                // console.log(cellValues.row);
                return (
                    <StockMutationCard skeleton={params.row.skeleton ?? false} {...params.row}/>
                    // <Box
                    //     sx={{
                    //         background:`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                    //         paddingX:2,
                    //         paddingY:1.5,
                    //         borderRadius:2
                    //     }}
                    // >

                    // </Box>
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetStockMutationsQuery}
                // gridActions={<GridActions></GridActions>} 
                title={t("mutations")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[2].field,type:"DESC"}}
                columns={columns}>
            </ShDataGrid2>

            {spLocationLoading && 
                <SpLocationDetails
                    isExtended={locationIsExtended}
                    setIsExtended={setLocationIsExtended}
                    locationId={locationId}
                />
            }
        </Box>
    );
}

export default Mutations;